import {getStore} from 'redux-stores/Store';

import {StructuredTableEditStatus} from './reduceToggledTableEditState';

/**
 * Redux actions (and associated constants) for toggling structured table edit state.
 * See makeToggleEditModeActionFunction for more details
 */

export enum StructuredTableTogglableStateActionType {
  STRUCTURED_TABLE_TOGGLABLE_EDIT_STATE_SET = 'STRUCTURED_TABLE_TOGGLABLE_EDIT_STATE_SET',
}

interface StructuredTableTogglableStatusActionSet {
  type: StructuredTableTogglableStateActionType.STRUCTURED_TABLE_TOGGLABLE_EDIT_STATE_SET;
  tableCid: string;
  editStatus: StructuredTableEditStatus;
}

// Exported for testing only
export function _structuredTableTogglableStatusSet(
  tableCid: string,
  editStatus: StructuredTableEditStatus
): StructuredTableTogglableStatusActionSet {
  return {
    type: StructuredTableTogglableStateActionType.STRUCTURED_TABLE_TOGGLABLE_EDIT_STATE_SET,
    tableCid,
    editStatus,
  };
}

export function setStructuredTableTogglableStatus(
  tableCid: string,
  editStatus: StructuredTableEditStatus
): void {
  getStore().dispatch(_structuredTableTogglableStatusSet(tableCid, editStatus));
}

export function getStructuredTableTogglableStatus(tableCid: string): StructuredTableEditStatus {
  return getStore().getState().ui.structuredTableEditState[tableCid] ?? StructuredTableEditStatus.LOCKED;
}

export type StructuredTableTogglableStateAction = StructuredTableTogglableStatusActionSet;
